webpackJsonp([0,2],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(6)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(3),
  /* template */
  __webpack_require__(9),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Scroller__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Scroller__);




/* harmony default export */ __webpack_exports__["default"] = {
  name: 'app',
  data: function data() {
    return {
      vList: [{ value: 1, name: 'item 1', selected: false }, { value: 2, name: 'item 2', selected: false }, { value: 3, name: 'item 3', selected: false }, { value: 4, name: 'item 4', selected: true }, { value: 5, name: 'item 5', selected: false }, { value: 6, name: 'item 6', selected: false }, { value: 7, name: 'item 7', selected: false }, { value: 8, name: 'item 8', selected: false }],
      vTitle: 'List Title'
    };
  },

  components: {
    Scroller: __WEBPACK_IMPORTED_MODULE_0__components_Scroller___default.a
  }
};

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _this5 = this;

/* harmony default export */ __webpack_exports__["default"] = {
  name: 'Scroller',
  props: {
    scrollerTitle: String,
    itemList: Array
  },
  data: function data() {
    return {
      selectedIndex: 0,
      selectedValue: 1,
      startPosY: 0,
      currentPosY: 0,
      startTime: 0,
      endTime: 0,
      lastTime: new Date().getTime(),
      transitionDuration: 0,
      lastPosY: 0,
      lastV: 0,
      startTranslatedY: 80,
      currentTranslatedY: 80,
      havedClicked: false,
      isMouseDown: false,
      totalHeight: 40
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var supportedTouch = false;
    this.initData();
    if ('ontouchstart' in window) {
      supportedTouch = true;
    }
    if (supportedTouch) {
      this.bindTouchEvents();
    } else {
      this.bindMouseEvents();
    }
    this.bindClickEvent();
  },

  computed: {},
  methods: {
    initData: function initData() {
      var _this = this;

      if (this.itemList.length > 0) {
        this.itemList.forEach(function (item, index) {
          if (item.selected === true) {
            _this.selectedValue = item.value;
            _this.selectedIndex = index;
            return false;
          }
          return true;
        });
        this.startTranslatedY = 80 - this.selectedIndex * 40;
        this.currentTranslatedY = this.startTranslatedY;
      } else {
        this.itemList = [{ value: 1, name: 'Please select..', selected: true }];
      }
      this.totalHeight = this.itemList.length * 40;
    },
    bindTouchEvents: function bindTouchEvents() {
      var _this2 = this;

      var el = this.$refs.ul;

      el.addEventListener('touchstart', function (e) {
        _this2.startPosY = e.changedTouches[0].pageY;
        _this2.currentPosY = _this2.startPosY;
        _this2.startTime = new Date().getTime();
        _this2.startTranslatedY = _this2.currentTranslatedY;
        _this2.lastV = 0;
      }, false);

      el.addEventListener('touchmove', function (e) {
        e.preventDefault();
        _this2.lastV = (e.changedTouches[0].pageY - _this2.lastPosY) / (new Date().getTime() - _this2.lastTime);
        _this2.currentPosY = e.changedTouches[0].pageY;
        _this2.currentTranslatedY = _this2.startTranslatedY + _this2.currentPosY - _this2.startPosY;
        _this2.lastPosY = _this2.currentPosY;
        _this2.lastTime = new Date().getTime();
      }, false);

      el.addEventListener('touchend', function () {
        _this2.endTime = new Date().getTime();
        if (Math.abs(_this2.currentPosY - _this2.startPosY) > 5 && _this2.endTime - _this2.startTime > 50) {
          var v = _this2.lastV;
          var s = v > 0 ? 0.5 * Math.pow(v, 2) / 0.001 : -0.5 * Math.pow(v, 2) / 0.001;
          var t = Math.abs(v) / 0.001;
          var currentTranslatedY = _this2.currentTranslatedY;
          currentTranslatedY += s;
          var residue = currentTranslatedY % 40;
          if (Math.abs(residue) >= 20) {
            if (residue < 0) {
              currentTranslatedY += (40 + residue) * -1;
            } else {
              currentTranslatedY += 40 - residue;
            }
          } else {
            currentTranslatedY -= residue;
          }
          if (currentTranslatedY > 80) {
            currentTranslatedY = 80;
          } else if (currentTranslatedY < (_this2.totalHeight - 120) * -1) {
            currentTranslatedY = (_this2.totalHeight - 120) * -1;
          }
          var selectedIndex = Math.abs((currentTranslatedY - 80) / -40);
          _this2.transitionDuration = t;
          _this2.currentTranslatedY = currentTranslatedY;
          setTimeout(function () {
            _this2.itemList[_this2.selectedIndex].selected = false;
            _this2.selectedIndex = selectedIndex;
            _this2.itemList[_this2.selectedIndex].selected = true;
            _this2.selectedValue = _this2.itemList[_this2.selectedIndex].value;
            _this2.havedClicked = false;
          }, t);
        } else {
          _this2.havedClicked = true;
        }
        _this2.startPosY = 0;
        _this2.currentPosY = 0;
        _this2.startTranslatedY = 0;
        _this2.startTime = 0;
        _this2.endTime = 0;
        _this2.lastPosY = 0;
        _this2.lastV = 0;
      }, false);
    },
    bindMouseEvents: function bindMouseEvents() {
      var _this3 = this;

      var el = this.$refs.ul;
      var mouseDown = null;
      var mouseMove = null;
      var _mouseUp = null;
      var mouseLeave = null;
      var mouseWheel = null;

      mouseDown = function mouseDown(e) {
        _this3.isMouseDown = true;
        _this3.startPosY = e.pageY;
        _this3.currentPosY = _this3.startPosY;
        _this3.startTime = new Date().getTime();
        _this3.startTranslatedY = _this3.currentTranslatedY;
        el.addEventListener('mousemove', mouseMove);
        el.addEventListener('mouseup', _mouseUp);
        el.addEventListener('mouseleave', mouseLeave);
      };
      mouseMove = function mouseMove(e) {
        if (_this3.isMouseDown) {
          e.preventDefault();
          _this3.lastV = (e.pageY - _this3.lastPosY) / (new Date().getTime() - _this3.lastTime);
          _this3.currentPosY = e.pageY;
          _this3.currentTranslatedY = _this3.startTranslatedY + _this3.currentPosY - _this3.startPosY;
          _this3.lastPosY = _this3.currentPosY;
          _this3.lastTime = new Date().getTime();
          _this3.havedClicked = false;
        }
      };
      _mouseUp = function mouseUp() {
        _this3.endTime = new Date().getTime();
        if (Math.abs(_this3.currentPosY - _this3.startPosY) > 5 && _this3.endTime - _this3.startTime > 20) {
          var v = _this3.lastV;
          var s = v > 0 ? 0.5 * Math.pow(v, 2) / 0.001 : -0.5 * Math.pow(v, 2) / 0.001;
          var t = Math.abs(v) / 0.001;
          var currentTranslatedY = _this3.currentTranslatedY;
          currentTranslatedY += s;
          var residue = currentTranslatedY % 40;
          if (Math.abs(residue) >= 20) {
            if (residue < 0) {
              currentTranslatedY += (40 + residue) * -1;
            } else {
              currentTranslatedY += 40 - residue;
            }
          } else {
            currentTranslatedY -= residue;
          }
          if (currentTranslatedY > 80) {
            currentTranslatedY = 80;
          } else if (currentTranslatedY < (_this3.totalHeight - 120) * -1) {
            currentTranslatedY = (_this3.totalHeight - 120) * -1;
          }
          var selectedIndex = Math.abs((currentTranslatedY - 80) / -40);
          _this3.transitionDuration = t;
          _this3.currentTranslatedY = currentTranslatedY;
          setTimeout(function () {
            _this3.itemList[_this3.selectedIndex].selected = false;
            _this3.selectedIndex = selectedIndex;
            _this3.itemList[_this3.selectedIndex].selected = true;
            _this3.selectedValue = _this3.itemList[_this3.selectedIndex].value;
            _this3.havedClicked = false;
          }, t);
        } else {
          _this3.havedClicked = true;
        }
        _this3.startPosY = 0;
        _this3.currentPosY = 0;
        _this3.startTranslatedY = 0;
        _this3.startTime = 0;
        _this3.endTime = 0;
        _this3.lastPosY = 0;
        _this3.lastV = 0;
        _this3.isMouseDown = false;
        el.removeEventListener('mousemove', mouseMove);
        el.removeEventListener('mouseup', _mouseUp);
        el.removeEventListener('mouseleave', mouseLeave);
      };
      mouseLeave = function mouseLeave() {
        if (_this3.isMouseDown) {
          _mouseUp();
        }
      };
      mouseWheel = function mouseWheel(e) {
        _this3.startTranslatedY = _this3.currentTranslatedY;
        var currentTranslatedY = _this3.startTranslatedY + e.deltaY * 0.5;
        var residue = currentTranslatedY % 40;
        if (Math.abs(residue) >= 20) {
          if (residue < 0) {
            currentTranslatedY += (40 + residue) * -1;
          } else {
            currentTranslatedY += 40 - residue;
          }
        } else {
          currentTranslatedY -= residue;
        }
        if (currentTranslatedY > 80) {
          currentTranslatedY = 80;
        } else if (currentTranslatedY < (_this3.totalHeight - 120) * -1) {
          currentTranslatedY = (_this3.totalHeight - 120) * -1;
        }
        _this3.transitionDuration = 0.2;
        _this3.currentTranslatedY = currentTranslatedY;
        var selectedIndex = Math.abs((currentTranslatedY - 80) / -40);
        setTimeout(function () {
          _this3.itemList[_this3.selectedIndex].selected = false;
          _this3.selectedIndex = selectedIndex;
          _this3.itemList[_this3.selectedIndex].selected = true;
          _this3.selectedValue = _this3.itemList[_this3.selectedIndex].value;
        }, _this3.transitionDuration);
        _this3.startTranslatedY = 0;
      };

      el.addEventListener('mousedown', mouseDown);
      el.addEventListener('wheel', mouseWheel);
    },
    bindClickEvent: function bindClickEvent() {
      var _this4 = this;

      var el = this.$refs.ul;
      el.querySelectorAll('li').forEach(function ($li, index) {
        $li.addEventListener('click', function () {
          if (_this4.havedClicked) {
            var itemPositionY = $li.offsetTop;
            var currentTranslatedY = 80 - itemPositionY;
            _this4.transitionDuration = 0;
            _this4.currentTranslatedY = currentTranslatedY;
            _this4.itemList[_this4.selectedIndex].selected = false;
            _this4.selectedIndex = index;
            _this4.itemList[_this4.selectedIndex].selected = true;
            _this4.selectedValue = _this4.itemList[_this4.selectedIndex].value;
            _this4.havedClicked = false;
          }
        });
        return true;
      });
    }
  },
  watch: {
    itemList: function itemList() {
      _this5.totalHeight = _this5.itemList.length * 40;
    }
  }
};

/***/ }),
/* 5 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(5)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(4),
  /* template */
  __webpack_require__(8),
  /* scopeId */
  "data-v-0e1129fb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vscroller"
  }, [_c('div', {
    staticClass: "vscroller__head"
  }, [_vm._v(_vm._s(_vm.scrollerTitle))]), _vm._v(" "), _c('div', {
    staticClass: "vscroller__body"
  }, [_c('ul', {
    ref: "ul",
    style: ({
      webkitTransition: '-webkit-transform ' + _vm.transitionDuration / 1000 + 's ease-out',
      transition: 'transform ' + _vm.transitionDuration / 1000 + 's ease-out',
      webkitTransform: 'translate3d(0px, ' + _vm.currentTranslatedY + 'px, 0px)',
      transform: 'translate3d(0px, ' + _vm.currentTranslatedY + 'px, 0px)'
    })
  }, _vm._l((_vm.itemList), function(item) {
    return _c('li', {
      key: item.id,
      class: item.selected ? 'vselected' : '',
      attrs: {
        "data-val": item.value
      }
    }, [_vm._v(_vm._s(item.name))])
  }))])])
},staticRenderFns: []}

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('scroller', {
    attrs: {
      "scrollerTitle": _vm.vTitle,
      "itemList": _vm.vList
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ })
],[12]);


// WEBPACK FOOTER //
// static/js/app.dc0e50cdd91d2b217192.js